import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { CreateMailTemplateRequest, MailTemplateService, UpdateMailTemplateRequest } from '../../../../../../api';
import { QueryKey } from '../../../../../constants/query-key';

@Injectable()
export class MailTemplateCommandService {
  private readonly mailTemplateService = inject(MailTemplateService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateMailTemplateRequest) =>
      lastValueFrom(this.mailTemplateService.createMailTemplate(request)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.MAIL_TEMPLATES] });
    },
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateMailTemplateRequest }) =>
      lastValueFrom(this.mailTemplateService.updateMailTemplate(request.id, request.body)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.MAIL_TEMPLATES] });
    },
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) => lastValueFrom(this.mailTemplateService.deleteMailTemplate(id)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.MAIL_TEMPLATES] });
    },
  }));
}
